// LernoDownloadLookup.js — Self-service "I lost my email" recovery.
// Public no-login form. Enter PO# + coordinator email → we email the
// magic link again if the order exists. Always shows the same success
// message regardless of whether the order was found (no info leaks).
import React, { useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function LernoDownloadLookup() {
  const [po, setPo] = useState("");
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!po.trim() || !email.trim()) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/api/lerno/resend-link`, {
        po_number: po.trim(),
        ell_coordinator_email: email.trim().toLowerCase(),
      });
      setMsg({ kind: "ok",
        text: "If a matching order exists, we've re-sent the download link to that email. Check your inbox (and spam folder) in the next few minutes." });
    } catch (err) {
      setMsg({ kind: "err", text: "Something went wrong. Please contact LERNO CO." });
    } finally { setSubmitting(false); }
  };

  return (
    <div style={{ minHeight:"100vh", background:"#F8FAFC",
      fontFamily:"-apple-system,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
      color:"#0F172A", padding:"48px 20px" }}>
      <div style={{ maxWidth:520, margin:"0 auto", background:"#FFF",
        borderRadius:12, boxShadow:"0 1px 3px rgba(15,23,42,0.08)", overflow:"hidden" }}>
        <div style={{ padding:"24px 32px", borderBottom:"2px solid #1E293B" }}>
          <div style={{ fontSize:11, letterSpacing:1.5, textTransform:"uppercase",
            color:"#64748B", marginBottom:4 }} data-testid="lerno-lookup-brand">
            LERNO CO · MOSAIC Print Materials
          </div>
          <h1 style={{ fontSize:22, margin:0, letterSpacing:-0.3 }}>Recover download link</h1>
          <div style={{ color:"#64748B", fontSize:13, marginTop:4 }}>
            Lost the original email? Enter your Purchase Order number and
            ELL Coordinator email below. If we find a matching active order,
            we'll re-send the download link.
          </div>
        </div>
        <form onSubmit={submit} style={{ padding:"32px" }}>
          <div style={{ marginBottom:20 }}>
            <label style={{ fontSize:12, textTransform:"uppercase",
              color:"#64748B", letterSpacing:0.8 }}>Purchase Order #</label>
            <input data-testid="lerno-lookup-po" type="text" value={po}
              onChange={(e) => setPo(e.target.value)} required
              style={{ width:"100%", marginTop:6, padding:12, borderRadius:6,
                border:"1px solid #CBD5E1", fontSize:14, boxSizing:"border-box" }} />
          </div>
          <div style={{ marginBottom:24 }}>
            <label style={{ fontSize:12, textTransform:"uppercase",
              color:"#64748B", letterSpacing:0.8 }}>ELL Coordinator email</label>
            <input data-testid="lerno-lookup-email" type="email" value={email}
              onChange={(e) => setEmail(e.target.value)} required
              style={{ width:"100%", marginTop:6, padding:12, borderRadius:6,
                border:"1px solid #CBD5E1", fontSize:14, boxSizing:"border-box" }} />
          </div>
          <button data-testid="lerno-lookup-submit" type="submit" disabled={submitting}
            style={{ width:"100%", padding:"14px 24px",
              background: submitting ? "#94A3B8" : "#1E293B",
              color:"#FFF", border:"none", borderRadius:8, fontWeight:600,
              fontSize:15, cursor: submitting ? "not-allowed" : "pointer" }}>
            {submitting ? "Sending…" : "Re-send my download link"}
          </button>
          {msg && (
            <div data-testid="lerno-lookup-result" style={{ marginTop:20, padding:"12px 16px",
              borderRadius:6, fontSize:14,
              background: msg.kind==="ok" ? "#F0FDF4" : "#FEF2F2",
              color: msg.kind==="ok" ? "#166534" : "#7F1D1D" }}>
              {msg.text}
            </div>
          )}
          <div style={{ marginTop:24, fontSize:12, color:"#94A3B8", lineHeight:1.6 }}>
            For security we always show the same message whether or not
            we found a matching order. If nothing arrives in 10 minutes,
            double-check the PO # and email, or contact LERNO CO directly.
          </div>
        </form>
      </div>
    </div>
  );
}
